import React from 'react';
import PackageCard from '../components/PackageCard';
import { Helmet } from 'react-helmet-async';
const StandardLessonsPage = () => {
  const standardPackages = [{
    title: 'Trial 1st Session',
    price: '£40',
    description: '1 hour introductory lesson for new customers only.',
    features: ['Meet your instructor', 'Initial driving assessment', 'Personalised learning plan', 'No obligation to continue'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '2 Hour Package',
    price: '£76',
    originalPrice: '£80',
    description: '£38 per hour - Automatic lessons for beginners or refresher sessions.',
    features: ['Save £4 on standard pricing', 'Behind-the-wheel training', 'Traffic rules and regulations', 'Flexible scheduling'],
    saving: '£4',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '6 Hour Package',
    price: '£225',
    originalPrice: '£240',
    description: '£37.50 per hour - Build your confidence and skills with multiple sessions.',
    features: ['Save £15 on standard pricing', 'Comprehensive driving practice', 'Manoeuvre training', 'Urban and suburban driving'],
    saving: '£15',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '10 Hour Package',
    price: '£370',
    originalPrice: '£400',
    description: '£37 per hour - Popular standard package for automatic lessons.',
    features: ['Save £30 on standard pricing', 'Complete driving skills coverage', 'Junction and roundabout mastery', 'Test preparation guidance'],
    popular: false,
    saving: '£30',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '20 Hour Package',
    price: '£710',
    originalPrice: '£800',
    description: '£35.50 per hour - Comprehensive training for complete beginners.',
    features: ['Save £90 on standard pricing', 'Full driving curriculum', 'Advanced manoeuvres', 'Night driving practice'],
    popular: true,
    saving: '£90',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Driving Test Booking',
    price: '£110',
    description: 'For NDS customers only (cancellation charges apply).',
    features: ['Test appointment booking', "Use of instructor's car for test", 'Pre-test warm-up session', 'Post-test feedback'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-1724">
      <Helmet data-id="element-1725">
        <title data-id="element-1726">Automatic Driving Lessons & Intensive Courses Northampton</title>
        <meta name="description" content="Learn at your own pace with trial lessons, block bookings, or intensive driving courses in Northampton. Flexible packages and expert instruction." data-id="element-1727" />
        <meta name="keywords" content="automatic driving lessons Northampton, driving packages Northampton, block booking driving lessons, trial driving lesson Northampton" data-id="element-1728" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1729">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1730">
          Standard Driving Lessons
        </h1>
        <h2 className="sr-only" data-id="element-1731">Trial Driving Lessons in Northampton</h2>
        <h2 className="sr-only" data-id="element-1732">Block Booking Discounts for Driving Lessons</h2>
        <h2 className="sr-only" data-id="element-1733">
          Automatic Driving Lesson Packages Northampton
        </h2>
        <div className="mb-8" data-id="element-1734">
          <p className="text-gray-700" data-id="element-1735">
            Our standard driving lessons are designed to fit around your
            schedule, allowing you to learn at your own pace. All lessons are
            conducted in automatic cars by qualified instructors who will tailor
            their teaching to your individual needs.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-1736">
          {standardPackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1737" />)}
        </div>
        <div className="bg-gray-50 rounded-lg p-8 mb-12" data-id="element-1738">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1739">
            What's Included in Our Standard Lessons?
          </h2>
          <ul className="space-y-4" data-id="element-1740">
            <li className="flex" data-id="element-1741">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1742">
                ✓
              </div>
              <div data-id="element-1743">
                <strong data-id="element-1744">Personalised Instruction</strong> - Lessons tailored to
                your learning style and experience level.
              </div>
            </li>
            <li className="flex" data-id="element-1745">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1746">
                ✓
              </div>
              <div data-id="element-1747">
                <strong data-id="element-1748">Automatic Vehicles</strong> - Modern, dual-controlled
                automatic cars that are easy to learn in.
              </div>
            </li>
            <li className="flex" data-id="element-1749">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1750">
                ✓
              </div>
              <div data-id="element-1751">
                <strong data-id="element-1752">Comprehensive Coverage</strong> - All aspects of
                driving, from basics to advanced manoeuvres.
              </div>
            </li>
            <li className="flex" data-id="element-1753">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1754">
                ✓
              </div>
              <div data-id="element-1755">
                <strong data-id="element-1756">Flexible Scheduling</strong> - Lessons available
                weekdays, evenings, and weekends.
              </div>
            </li>
            <li className="flex" data-id="element-1757">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1758">
                ✓
              </div>
              <div data-id="element-1759">
                <strong data-id="element-1760">Progress Tracking</strong> - Regular feedback and
                progress updates.
              </div>
            </li>
          </ul>
        </div>
        <div className="text-center" data-id="element-1761">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1762">Ready to Get Started?</h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-1763">
            Book your first lesson today or contact us to discuss which package
            would be best for your needs.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your driving lessons in Northampton" data-id="element-1764">
            Book Now
          </a>
        </div>
      </div>
    </div>;
};
export default StandardLessonsPage;